<template>
  <div class="courseForm" :data="dataschedule">
    <div v-if="dataschedule.length==0" class="noResultInfo">
      <p class="font_24_reg">{{$t('tabBar.noLesson')}}</p>
      <p class="font_24_reg">{{$t('tabBar.download')}}</p>
      <div class="flex_justify_center">
        <img @click="utils.toAppStore()" src="../../assets/Download_App_Store.svg" style="margin-right: 20px;" />
        <img @click="utils.toGooglePlay()" src="../../assets/google-play-badge.png" />
      </div>
    </div>
    <div class="courseList" v-else>
        <div class="classList" v-for="(item,i) in dataschedule" :key='i'>
          <div class="flex_between titleBorder">
            <div class="titleName flex_center">
              <img :src="item.subject_img"/>
              <h3 class="font_24_bold">{{item.subject_title}} - {{item.start_lessons}}/{{item.total_lessons}}</h3>
              <p v-if="item.attends_status==1" class="leaveIdent">{{$t('main.leave')}}</p>
            </div>
            <button :class="item.status==0&&item.mins?'willStartIn':(item.status==1?'pending':(item.status==2?'completed':(item.status==3?'cancel':'btnNone')))">
              {{item.status==0&&item.mins?$t('main.timeOut')+item.mins:(item.status==1?$t('main.inProgress'):(item.status==2?$t('main.completed'):(item.status==3?$t('main.cancel'):'')))}}
            </button>
          </div>
          <div class="classTimeInfo">
            <div class="flex_between titleName">
              <p class="font_24_reg">{{item.start_date}}</p>
              <button class="font_16">{{item.level_title}}</button>
            </div>
              <p class="font_18_reg">{{item.start_time}} ({{item.duration}}{{$t('main.mins')}})</p>
              <div class="flex_center topic"><p class="classTopic font_14 color_blue">{{$t('main.topic')}}</p><p class="font_18_reg">{{item.lesson_topic}}</p></div>
              <div class="flex_center topic"><p class="classTopic font_14 color_blue">{{$t('main.attendee')}} </p><img :src="item.student_avatar" /><p class="font_18_reg">{{item.nickname}}</p></div>
              <!-- <div class="studentList flex_start">
                <div class="regularList">
                  <p class="color_grey">Regular Student(s)</p>
                  <div class="stuArr"><p title="Esther Howard">Esther Howard</p></div>
                </div>
                <div class="dropinList">
                  <p class="color_grey">Drop-in Student(s)</p>
                  <div class="stuArr"><p title="Esther Howard">Esther Howard</p></div>
                </div>
              </div> -->
              <div class="flex_between">
                <div class="actBtn flex_justify_center">
                  <!-- <button type="text" @click="open" :disabled="item.status==0" :class="item.status==0?'disabled':'leaveBtn'">Leave a Note</button> -->
                 <div>
                   <button type="text" @click="enterClassRoom(item)" :disabled="item.status==3||item.status==2||((item.status==0||item.status==1)&&!item.enterStatus)" :class="item.status!=3&&item.status!=2&&item.enterStatus?'enterClass':'disabled'">{{$t('main.enterClassRoom')}}</button>
                   <el-tooltip :content="$t('main.beginToEnter')" placement="right" effect="light">
                     <img src="../../assets/help-circle.svg">
                   </el-tooltip>
                   <div class="tips">{{item.message}}</div>
                 </div>
                </div>

                <el-dropdown @command="handleCommand(item)" class="LeavePopover" v-if="item.is_attends&&item.sickStatus">
                  <el-button class="rightHead">
                    <img src="../../assets/more-vertical.svg" />
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="sickPop" command="sickLeave">{{$t('main.requestLeave')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>

          </div>
        </div>
    </div>
    <div v-if="isShoSick" class="el-message-box__wrapper" style="z-index: 2010;background:rgb(0 0 0 / 30%)">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title center">
            <b>{{$t('main.sickTitle')}}</b>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <p class="center">{{$t('main.askTo')}} <b>{{commandData.nickname}}</b> {{$t('main.currentCredit')}}</p>
              <div>
                <p><b>{{$t('main.subject')}}: </b>{{commandData.subject_title}}</p>
                <p><b>{{$t('main.date')}}: </b>{{commandData.start_date}}</p>
                <p><b>{{$t('main.time')}}: </b>{{commandData.start_time}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small el-button--primary" @click="submitSick">
            <span>{{$t('main.confirmSick')}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataschedule: Array,
    required: true
  },
  data () {
    return {
      data: [],
      commandData: {},
      interval: null,
      isShoSick: false
    }
  },
  created () {
    console.log(this.dataschedule)
    if (this.interval) { // 判断定时器这个属性是否为空,存在则清除
      clearInterval(this.interval)
    }
    this.interval = setInterval(() => { // 这个interval是在data(){return{}} 中创建，初始化为null 防止重复请求到这个页面定时器重复生成
      this.timeStatus()
      this.$forceUpdate()
      // for ( let i = 0 ; i<this.scheduleData.length ; i++){
      //     this.scheduleData[i].mins = this.computeTime(new Date(item.start_at).getTime() - nowDate.getTime())
      // }
    }, 1000)
  },
  methods: {
    handleCommand (command) {
      this.isShoSick = true
      this.commandData = command
    },
    chooseImg () {
      this.isShoSick = !this.isShoSick
    },
    submitSick () {
      this.$http.post('/api/edu/lesson-attends', {
        lesson_sn: this.commandData.lesson_sn,
        student_sn: this.commandData.student_sn
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.isShoSick = !this.isShoSick
          this.$notify({
            message: res.data.msg,
            duration: 0
          })
          this.$emit('sickSuc', true)
          this.dataschedule.map((item) => {
            if (item.lesson_sn == res.data.data.lesson_sn && item.student_sn == res.data.data.student_sn && res.data.data.status != 0) {
              item.is_attends = false
            }
          })
          this.$forceUpdate()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    timeStatus () {
      for (var i in this.dataschedule) {
        this.dataschedule.map((timeItem, j) => {
          // let nowDate = new Date();
          // var date3 = new Date(timeItem.start_at).getTime() - nowDate.getTime();
          // console.log(date3)
          // if( date3 < 172800000){
          //     timeItem.mins= this.timeStatus(timeItem.start_at)
          // }else if(date3 < 300000){ //五分钟内才能进入教室
          //     timeItem.enterStatus = true;
          // }
          var hoursRound = ''
          var minutesRound = ''
          let beg = this.utils.formatDate(timeItem.start_at).getTime() // 开始秒数

          let now = new Date().getTime()
          let begTime = beg - now
          if (begTime >= 0 && begTime < 172800000) {
            hoursRound = Math.floor(begTime / 1000 / 60 / 60)
            minutesRound = Math.floor(begTime / 1000 / 60 % 60)
            timeItem.mins = hoursRound + this.$t('main.hours') + minutesRound + this.$t('main.mins')
          }
          if (begTime < 300000) { // 五分钟内才能进入教室
            timeItem.enterStatus = true
          }
          if (begTime > 10800000) {
            timeItem.sickStatus = true
          }
        })
      }
      return this.scheduleData
    },
    enterClassRoom (data) {
      this.$http.post('/api/enterRoom/', {lesson_sn: data.lesson_sn, student_sn: data.student_sn}).then((res) => {
        window.open(res.data.data.url)
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  }
}
</script>

<style lang="less" scoped>
.courseForm{
  margin-top:25px;
  .noResultInfo{
    margin-top:80px;
    text-align: center;
    p{
      margin-bottom:32px;
    }
  }
  .courseList{
    margin:0 15px;
    >p.font_24_bold{
      margin:15px 0;
    }
    .classList{
      margin: 12px 0;
      background: #f8f8f8;
      border-radius: 5px;
      padding:15px 20px;
      .titleBorder{
        padding:10px;
        border-bottom: 1px solid rgba(165, 165, 165, 0.5);
      }
      .titleName{
        margin:10px 0;
        >img{
          width:21px;
          height:24px;
          margin-right:10px;
        }
        >span{
          width:6px;
          height:6px;
          border-radius: 2px;
          background: #a5a5a5;
          margin:0 20px;
        }
        >button{
          height: 36px;
          line-height: 36px;
          padding:0 10px;
          border:none;
          border-radius: 30px;
          background: #ffb800;
          color:#000;
        }
        .leaveIdent{
          color: #fff;
          padding:5px 10px;
          margin-left:20px;
          border-radius: 7px;
          background: #8d8d8d;
          border-radius: 5px;
          font-size: 16px;
          font-family: Sofia Pro-Regular;
        }
      }
      .classTimeInfo{
        margin-left:15px;
        margin-top:10px;
        .topic{
          margin-top:12px;
          .classTopic{
            margin-right:16px;
          }
          img{
            width:30px;
            height:30px;
            margin-right:8px;
          }
        }
        .tips{
          color: #ff6440;
          text-align: center;
          padding-right: 30px;
          box-sizing: border-box;
        }
        .studentList{
          background: #ffffff;
          border-radius: 8px;
          margin:10px 0 32px 0;
          padding:7px 0;
          >div{
            flex:1;
            padding:7px 16px;
            >.color_grey{
              margin-bottom:10px;
            }
            >.stuArr{
              line-height: 24px;
              p{
                width:100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
              }
            }
          }
          .regularList{
            border-right:1px solid #F8F8F8;
          }
        }
        .actBtn{
          width: 100%;
          button{
            width:200px;
            height:50px;
            margin-right:10px;
          }
          img{
            box-shadow: 0px 1px 6px 1px rgba(81,124,255,0.20);
            border-radius: 50%;
            cursor: pointer;
          }
        }
        /deep/ .el-dropdown{
          .rightHead{
            background: none;
            border:none;
            color:#fff;
            font-size: 32px;
            padding:0;
            span{
              img{
                width:32px;
                height:32px;
              }
            }

          }
        }
      }
    }
  }
  .el-message-box__header{
    padding: 25px 84px 0;
    .el-message-box__title{
      margin-bottom:10px;
    }
    .el-message-box__headerbtn{
      top:25px;
    }
  }
  .el-message-box__content{
    color:#353643;
    .el-message-box__message{
      >p{
        margin-bottom: 40px;
      }
      >div{
        text-align: left;
        margin:20px 0 40px 140px;
        p{
          line-height: 34px;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/views/scheduled.vue